import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Search, ArrowLeft, Briefcase, Megaphone, Users, MapPin, Hotel, BookOpen, PlayCircle,
  Brain, MessageCircle, Mail, Database, ScanLine, Package, Send, FileText, Calendar,
  UserCheck, Image as ImageIcon, ClipboardList, BarChart3, Settings, Lock, Layers
} from "lucide-react";

const SECTIONS = [
  {
    title: "🎓 Accademia & Corsi",
    color: "purple",
    items: [
      { path: "/admin/corsi", label: "Gestione Videocorsi", desc: "Crea, modifica, elimina i video corsi", icon: PlayCircle, hot: true },
      { path: "/admin/iscrizioni", label: "Iscrizioni Corsi", desc: "Vedi tutte le iscrizioni degli studenti", icon: ClipboardList },
      { path: "/admin/sessioni", label: "Sessioni / Calendario", desc: "Pianifica le sessioni live", icon: Calendar },
      { path: "/admin/docenti", label: "Docenti", desc: "Gestione docenti e relatori", icon: UserCheck },
      { path: "/admin/accademia", label: "Approvazioni Accademia", desc: "Approva nuovi iscritti, invia credenziali", icon: Lock, hot: true },
      { path: "/admin/quiz-risposte", label: "Quiz & Test Valutazione", desc: "Risultati quiz studenti", icon: FileText },
      { path: "/admin/materiali", label: "Materiali Didattici", desc: "Allegati e PDF dei corsi", icon: FileText },
      { path: "/admin/utenti", label: "Utenti Piattaforma", desc: "Tutti gli utenti registrati", icon: Users },
    ],
  },
  {
    title: "💼 CRM ITA318 & Vendite",
    color: "amber",
    items: [
      { path: "/admin/crm", label: "Dashboard CRM", desc: "Vista sintetica clienti e ordini", icon: Briefcase, hot: true },
      { path: "/admin/crm/clienti", label: "Clienti ITA318", desc: "Lista completa con colori giorni inattivo", icon: Users, hot: true },
      { path: "/admin/crm/ordini", label: "Ordini in attesa", desc: "Approva, modifica o respingi ordini email", icon: ClipboardList },
      { path: "/admin/crm/import", label: "Import Excel DDT/Fatture", desc: "Carica anagrafiche e storico ordini", icon: Database, hot: true },
      { path: "/admin/crm/outlook", label: "Config Outlook IMAP", desc: "Connessione ODR.ORDINI@ITA318.IT", icon: Mail },
      { path: "/admin/potenziali-clienti", label: "Potenziali Clienti", desc: "Lead in attesa di follow-up", icon: UserCheck },
      { path: "/admin/contatti-fiera", label: "Contatti Fiera", desc: "Lead acquisiti agli eventi", icon: ScanLine },
      { path: "/admin/hotel-spa", label: "Hotel & Luxury SPA", desc: "Partnership con strutture", icon: Hotel },
      { path: "/admin/marketing", label: "Database Marketing", desc: "Audience e segmentazioni", icon: Database },
      { path: "/admin/referenti", label: "Distributori / Agenti", desc: "Anagrafica forza vendita", icon: Users },
    ],
  },
  {
    title: "🗺️ Network & Mappa",
    color: "violet",
    items: [
      { path: "/admin/network-map", label: "ODR Global Network", desc: "Mappa interattiva centri, distributori, agenti", icon: MapPin, hot: true },
      { path: "/admin/magazzino", label: "Magazzino ODR", desc: "Scorte, prelievi, movimenti", icon: Package },
      { path: "/admin/associazioni", label: "Associazioni", desc: "Partner istituzionali", icon: Layers },
    ],
  },
  {
    title: "📢 Marketing & Comunicazione",
    color: "rose",
    items: [
      { path: "/admin/bacheca", label: "Bacheca ODR", desc: "Comunicazioni interne + WhatsApp + Eventi", icon: Megaphone, hot: true },
      { path: "/admin/comunicazioni", label: "Automazioni Multi-canale", desc: "Regole Telegram + Email + WhatsApp", icon: Send },
      { path: "/admin/whatsapp", label: "WhatsApp ODR", desc: "Broadcast e template", icon: MessageCircle },
      { path: "/admin/telegram", label: "Telegram @ODRacademyBot", desc: "Stats bot + post manuali", icon: MessageCircle },
      { path: "/admin/newsletter", label: "Newsletter", desc: "Liste iscritti e campagne email", icon: Mail },
      { path: "/admin/easter-email", label: "Email Stagionali", desc: "Pasqua, Natale ecc.", icon: Mail },
      { path: "/admin/feedback-campagna", label: "Feedback Campagne", desc: "Risposte clienti alle campagne", icon: BarChart3 },
    ],
  },
  {
    title: "🤖 AI & Generazione Contenuti",
    color: "indigo",
    items: [
      { path: "/admin/blog-wp", label: "Blog WordPress ODR", desc: "Articoli generati con GPT-4o", icon: FileText, hot: true },
      { path: "/admin/ai-engine", label: "AI Engine", desc: "Motore generazione testi/immagini", icon: Brain },
      { path: "/admin/video-generator", label: "Video Generator PRO", desc: "Crea video slide automatici", icon: PlayCircle },
      { path: "/admin/skin-analysis", label: "Analisi Pelle & Capelli", desc: "APM Pro 300 GPT Vision", icon: ImageIcon },
      { path: "/admin/mammouth-ai", label: "Mammouth AI", desc: "Pipeline AI avanzata", icon: Brain },
      { path: "/admin/solea", label: "SOLEA", desc: "Assistente conversazionale", icon: Brain },
      { path: "/admin/tecniche-benessere", label: "Tecniche di Benessere", desc: "Catalogo contenuti", icon: BookOpen },
      { path: "/admin/stories", label: "ODR Stories", desc: "Storie e casi di successo", icon: BookOpen },
    ],
  },
  {
    title: "⚙️ Sistema & Impostazioni",
    color: "slate",
    items: [
      { path: "/admin/personalizzazione", label: "Personalizzazione", desc: "Branding, loghi, colori", icon: Settings },
      { path: "/admin/documenti-contabili", label: "Documenti Contabili", desc: "Archivio fatture e DDT", icon: FileText },
    ],
  },
];

const COLOR_BORDER = {
  purple: "border-purple-200 hover:border-purple-400 hover:bg-purple-50",
  amber: "border-amber-200 hover:border-amber-400 hover:bg-amber-50",
  violet: "border-violet-200 hover:border-violet-400 hover:bg-violet-50",
  rose: "border-rose-200 hover:border-rose-400 hover:bg-rose-50",
  indigo: "border-indigo-200 hover:border-indigo-400 hover:bg-indigo-50",
  slate: "border-slate-200 hover:border-slate-400 hover:bg-slate-50",
};

const COLOR_ICON = {
  purple: "text-purple-600",
  amber: "text-amber-600",
  violet: "text-violet-600",
  rose: "text-rose-600",
  indigo: "text-indigo-600",
  slate: "text-slate-600",
};

export default function AdminMappaFunzionalitaPage() {
  const [search, setSearch] = useState("");
  const q = search.trim().toLowerCase();

  const filteredSections = SECTIONS.map((s) => ({
    ...s,
    items: s.items.filter(
      (it) => !q || it.label.toLowerCase().includes(q) || it.desc.toLowerCase().includes(q) || it.path.includes(q)
    ),
  })).filter((s) => s.items.length > 0);

  const totalItems = filteredSections.reduce((acc, s) => acc + s.items.length, 0);

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 to-amber-50 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-4">
          <Link to="/admin" className="text-[#7A4856] hover:underline text-sm" data-testid="back-to-admin">
            <ArrowLeft className="w-4 h-4 inline" /> Dashboard
          </Link>
        </div>

        <div className="mb-6">
          <h1 className="text-3xl font-bold text-[#5A3A3A]">🗺️ Mappa Funzionalità ODR Academy</h1>
          <p className="text-sm text-gray-600 mt-1">
            Elenco completo di TUTTE le pagine admin. Salva questa pagina nei preferiti per non perdere mai nulla.
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-rose-100 p-4 mb-6 sticky top-2 z-10 shadow-sm">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              data-testid="mappa-search"
              placeholder="Cerca: 'video', 'crm', 'whatsapp', 'magazzino', 'blog'..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-rose-200 rounded-full text-sm focus:outline-none focus:border-[#B87A8A]"
            />
          </div>
          <p className="text-xs text-gray-500 mt-2">
            {totalItems} funzionalità {q ? `corrispondenti a "${q}"` : "disponibili"} · {filteredSections.length} sezioni
          </p>
        </div>

        <div className="space-y-6">
          {filteredSections.map((sec) => (
            <div key={sec.title}>
              <h2 className={`text-lg font-bold mb-3 ${COLOR_ICON[sec.color]}`}>{sec.title}</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                {sec.items.map((it) => {
                  const Icon = it.icon || BookOpen;
                  return (
                    <Link
                      key={it.path}
                      to={it.path}
                      data-testid={`mappa-item-${it.path.replace(/\//g, "-").slice(1)}`}
                      className={`bg-white rounded-xl border-2 ${COLOR_BORDER[sec.color]} p-4 transition relative`}
                    >
                      {it.hot && (
                        <span className="absolute top-2 right-2 px-2 py-0.5 bg-amber-200 text-amber-800 rounded-full text-[10px] font-bold uppercase">
                          spesso usato
                        </span>
                      )}
                      <div className="flex items-start gap-3">
                        <Icon className={`w-6 h-6 ${COLOR_ICON[sec.color]} shrink-0`} />
                        <div className="flex-1 min-w-0">
                          <div className="font-semibold text-gray-800">{it.label}</div>
                          <div className="text-xs text-gray-500 mt-0.5">{it.desc}</div>
                          <div className="text-[10px] text-gray-400 mt-1 font-mono">{it.path}</div>
                        </div>
                      </div>
                    </Link>
                  );
                })}
              </div>
            </div>
          ))}
          {filteredSections.length === 0 && (
            <div className="text-center py-12 text-gray-400">Nessuna funzionalità trovata per "{search}"</div>
          )}
        </div>
      </div>
    </div>
  );
}
